<template>
  <span>
    {{ item.type }}: 
    <template v-if="location"> {{ location }}</template> 
    <template v-if="item.subject"> - {{ item.subject }}</template>
  </span>
</template>

<script>
export default {
  name: 'Reference',
  props: {
    item: {
      type: Object
    }
  },
  computed: {
    location () {
      let parts = []
      if (this.item.city) {
        parts.push(this.item.city)
      }
      if (this.item.state) {
        parts.push(this.item.state)
      }
      if (this.item.country) {
        parts.push(this.item.country)
      }
      return (parts.length ? parts.join(', ') : false)
    }
  }
}
</script>
